"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordRequestModel = void 0;
class ChangePasswordRequestModel {
    constructor(params) {
        this.confirmationPassword = params.confirmationPassword;
        this.currentPassword = params.currentPassword;
        this.newPassword = params.newPassword;
        this.includedAuthorizations = params.includedAuthorizations;
    }
    static fromJSON(props) {
        return new ChangePasswordRequestModel({
            confirmationPassword: props.confirmation_password,
            currentPassword: props.current_password,
            includedAuthorizations: props.includedAuthorizations,
            newPassword: props.new_password,
        });
    }
    toJSON() {
        return {
            confirmation_password: this.confirmationPassword,
            current_password: this.currentPassword,
            includedAuthorizations: this.includedAuthorizations,
            new_password: this.newPassword,
        };
    }
}
exports.ChangePasswordRequestModel = ChangePasswordRequestModel;
//# sourceMappingURL=ChangePasswordModel.js.map